module.exports = __webpack_public_path__ + "fonts/SFUIDisplay-Light.90ad2f0c.woff2";